<template>
  <van-dialog
    v-model="value"
    :title="title"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <slot class="dialog-content"></slot>
    <button
      class="
        van-button van-button--default van-button--largeitserve-app-color
        mt-25
      "
      @click="hideDialog"
    >
<!--      <template v-if="success">-->
<!--        &lt;!&ndash; Замена v-icon на собственный SVG с белым цветом &ndash;&gt;-->
<!--        <svg width="24" height="24" viewBox="0 0 512 512" class="dialog-confirm-icon" style="fill: #ffffff">-->
<!--          <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" fill="#ffffff"></path>-->
<!--        </svg>-->
<!--      </template>-->
<!--      <template v-else>-->
        <span class="modal-custom-ok">{{ $t("buttons.modalOkBtn") }}</span>
<!--      </template>-->
    </button>
  </van-dialog>
</template>

<script>
import "vue-awesome/icons/check";
import Dialog from "vant/lib/dialog/index";
export default {
  name: "SimpleDialog",
  props: {
    title: String,
    value: Boolean,
    success: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeTimeout: null,
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  watch: {
    value: function (val) {
      if (val === true) {
        this.closeTimeout = setTimeout(() => {
          // this.hideDialog();
        }, 5000);
      } else {
        clearTimeout(this.closeTimeout);
      }
    },
  },
  methods: {
    hideDialog() {
      this.$emit("input", false);
      this.$emit("change");
    },
  },
};
</script>

<style scoped>
@import "../../../node_modules/vant/lib/dialog/index.css";
@import "../../../node_modules/vant/lib/overlay/index.css";
@import "../../../node_modules/vant/lib/popup/index.css";
.dialog-confirm-icon {
  width: 24px;
  height: 24px;
  color: #ffffff;
}

/* Дополнительные стили для SVG-иконки */
.dialog-confirm-icon svg,
.dialog-confirm-icon svg path,
.dialog-confirm-icon svg g {
  fill: #ffffff !important;
  color: #ffffff !important;
  stroke: #ffffff !important;
}

/* Специфичные стили для пути галочки */
.dialog-confirm-icon svg path[d*="M 173.9 439.4"] {
  fill: #ffffff !important;
}

.modal-custom-ok {
  font-weight: bold;
  color: #2e73b4;
}
</style>
